import { makeStyles, mergeClasses } from "@fluentui/react-components";
import {
  AirplaneFilled,
  ClockFilled,
  DismissCircleFilled,
} from "@fluentui/react-icons";
import {
  $gray600,
  $moderateTextColor,
  $poorTextColor,
  $primary,
} from "../../cssjs/colors";
import { AirportFlights } from "../../models/airports/AirportConfig";
import { EMPTY_STATE_MESSAGE } from "../../utils/common/Constants";
import { NoDataCard } from "../common/no-data-card/NoDataCard";

interface IAirportFlightsCardProps {
  className?: string;
  flightData: AirportFlights;
  isError?: boolean;
  isMapView?: boolean;
}

const AirportFlightsCard: React.FunctionComponent<IAirportFlightsCardProps> = ({
  className,
  flightData,
  isError = false,
  isMapView = false,
}) => {
  const classes = useStyles();

  return (
    <div
      className={mergeClasses(classes.container, className)}
      data-testid="airport-flights-card"
    >
      <header className={classes.title}>Flights</header>
      {isError ? (
        <NoDataCard message={EMPTY_STATE_MESSAGE.Data} hideImage />
      ) : (
        <div className="d-flex">
          <div className="flex-1">
            <header className="fs-20 pb-sm-1">
              <AirplaneFilled
                aria-hidden="true"
                className={mergeClasses(classes.icon, classes.totalIcon)}
                data-testid="airport-flights-total-icon"
              />
              <span>{flightData.total.value}</span>
            </header>
            <footer>Total</footer>
          </div>
          {!isMapView && (
            <>
              <div className="flex-1">
                <header className="fs-20 pb-sm-1">
                  <ClockFilled
                    aria-hidden="true"
                    className={mergeClasses(classes.icon, classes.delayedIcon)}
                    data-testid="airport-flights-delayed-icon"
                  />
                  <span>{flightData.delayed.value}</span>
                </header>
                <footer>Delayed</footer>
              </div>
              <div className="flex-1">
                <header className="fs-20 pb-sm-1">
                  <DismissCircleFilled
                    aria-hidden="true"
                    className={mergeClasses(
                      classes.icon,
                      classes.cancelledIcon
                    )}
                    data-testid="airport-flights-cancelled-icon"
                  />
                  <span>{flightData.cancelled.value}</span>
                </header>
                <footer>Cancelled</footer>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AirportFlightsCard;

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
    padding: "6px 12px",
  },
  title: { color: $gray600, fontWeight: 500 },
  icon: {
    fontSize: "18px",
    verticalAlign: "bottom",
    paddingRight: "4px",
  },
  totalIcon: { color: $primary },
  delayedIcon: { color: $moderateTextColor },
  cancelledIcon: { color: $poorTextColor },
});
